/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-04-02 17:25:54
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2026-07-31 16:56:42
 * @FilePath: \app-client-h5\src\utils\util.js
 */
import {
    Toast,
} from 'antd-mobile';
import envConfig from '../config/env';
// 票据ip（环境地址统一在 src/config/env.js 中配置切换）
export const host = envConfig.ticket
export const handleToast = (text) => {
    Toast.show({
        content: text,
    })
}
export const GetRequest = () => {
    var url = window.location.search;
    // var url = decodeURIComponent(urls)
    var theRequest = new Object();
    if (url.indexOf("?") !== -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    return theRequest;
};
export const paramsSend = (url, data) => {
    let str = ''
    for (let item in data) {
        str += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'

    }
    str = str.slice(0, -1)
    str = url + '?' + str
    return str
}
export const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
}
export const getNewData = (dateTemp, days) => {
    console.log(dateTemp, days, 'dateTemp, days');
    dateTemp = dateTemp.split("-");
    var nDate = new Date(dateTemp[1] + '-' + dateTemp[2] + '-' + dateTemp[0]); //转换为MM-DD-YYYY格式    
    var millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
    var rDate = new Date(millSeconds);
    var year = rDate.getFullYear();
    var month = rDate.getMonth() + 1;
    if (month < 10) month = "0" + month;
    var date = rDate.getDate();
    if (date < 10) date = "0" + date;
    return (year + "-" + month + "-" + date);
}
//截流
export function throttle(func, wait) {
    let timeout;
    return function () {
        let context = this;
        let args = arguments;
        if (!timeout) {
            timeout = setTimeout(() => {
                timeout = null;
                func.apply(context, args)
            }, wait)
        }

    }
};
//防抖
export function debounce(func, wait) {
    let timeout;
    return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        let callNow = !timeout;
        timeout = setTimeout(() => {
            timeout = null;
        }, wait)

        if (callNow) func.apply(context, args)
    }
};

export function checkPassWord(word) {
    //let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
    let reg = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/
    if (reg.test(word)) {
        return true
    }
    return false
}
// 识别用户平台环境的函数
export function detectUserPlatform(customPhoneSystem) {
    console.log(customPhoneSystem,'customPhoneSystem');
    
    // 如果有自定义传入的phoneSystem，直接使用
    if (customPhoneSystem) {
        return customPhoneSystem;
    }
    const ua = navigator.userAgent.toLowerCase();
    console.log(ua,'ua');
    // 检测鸿蒙系统
    if (ua.includes('harmony') || ua.includes('harmonyos')) {
        return 'harmony';
    }

    // 检测微信小程序
    if (ua.includes('miniprogram') && ua.includes('micromessenger')) {
        return 'WeChat';
    }

    // 检测支付宝小程序
    if (ua.includes('miniprogram') && (ua.includes('alipay') || ua.includes('aliapp'))) {
        return 'Alipay';
    }

    // 检测微信公众号
    if (ua.includes('micromessenger')) {
        return 'WeChat';
    }

    // 检测支付宝服务号/生活号
    if (ua.includes('alipay')) {
        return 'Alipay';
    }

    // 检测iOS系统
    if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
        return 'ios';
    }

    // 检测Android系统
    if (ua.includes('android')) {
        return 'android';
    }

    // 默认返回未知
    return 'unknown';
};